import { createSelector } from "reselect";
import { decamelize } from "humps";

// Constants
import { exportNames, exportTypes } from "src/constants";

// Selectors
import {
  selectedLocationIdsSelector,
  answersFilterSelector
} from "src/selectors/section_selectors/evaluation_list/evaluation_list_wound_selector";
import { currentUserSelector } from "src/selectors/config_selectors/current_user_selector";
import { createArrayOfRevisionIdsSelector } from "src/selectors/data_selectors/wound_revisions";

// Api
import { createPostPayload } from "src/api/csv_exports/payload_generators";

// Utils
import { getUTCOffsetString } from "src/utils/get_UTC_offset_string/index.js";

export const assessmentSummaryWoundCsvExportPostPayloadSelector = createSelector(
  createArrayOfRevisionIdsSelector,
  currentUserSelector,
  selectedLocationIdsSelector,
  answersFilterSelector,
  (woundRevisionIds, currentUser, selectedLocationIds, answers) => {
    return createPostPayload({
      type: exportTypes.csvExports,
      workerType: decamelize(exportNames.evaluationListWound),
      userId: currentUser ? currentUser.id : "",
      userOffset: getUTCOffsetString(),
      parameters: {
        filter: {
          resource_id: woundRevisionIds.length
            ? woundRevisionIds.join()
            : undefined,
          resource_type: "Revision",
          location_id: selectedLocationIds.length
            ? selectedLocationIds
            : undefined,
          answers: answers && answers.length ? answers : undefined,
          patient_state: "admitted,new"
        },
        sort: "created_at"
      }
    });
  }
);
